import React, {FC} from 'react';
import './Cell.scss';
import {_, x} from "../../models/Game.model";

interface CellProps {
    value: string,
    onClick: () => void;
}

const Cell: FC<CellProps> = (props) => (
  <div className="Cell" data-testid="Cell" onClick={props.onClick}>
      <img src={props.value === _ ? "_.svg" : props.value === x ? "x.svg" : "o.svg"} alt={props.value === _ ? "" : props.value} />
  </div>
);

export default Cell;
